import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import ListGroup from "react-bootstrap/ListGroup";
import Badge from "react-bootstrap/Badge"; // добавляем импорт Badge

const ColCategory = observer(() => {
    const { book } = useContext(Context);
    const [hoveredItemId, setHoveredItemId] = useState(null);

    const handleGenreClick = (genre) => {
        if (book.selectedGenre && book.selectedGenre.id === genre.id) {
            book.setSelectedGenre('');
        } else {
            book.setSelectedGenre(genre);
        }
    };

    return (
        <div>
            <ListGroup>
                {book.genres
                    .filter((g) => g.type === "product")
                    .map((g) => (
                        <ListGroup.Item
                            title={g.genre}
                            key={g.id}
                            className={`list-group-item list-group-item-action small shadow-sm ${
                                hoveredItemId === g.id || book.selectedGenre?.id === g.id
                                    ? "list-group-item-success"
                                    : ""
                            }`}
                            style={{
                                cursor: "pointer",
                                borderRadius: ".25rem",
                                transition: "transform .2s",
                                boxShadow:
                                    hoveredItemId === g.id || book.selectedGenre?.id === g.id
                                        ? "0px 4px 12px rgba(0, 0, 0, 0.1)"
                                        : "none",
                                paddingTop: "0.10rem",
                                paddingBottom: "0.10rem",
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                position: "relative", // Важно для абсолютного позиционирования бейджа
                            }}
                            onMouseEnter={() => setHoveredItemId(g.id)}
                            onMouseLeave={() => setHoveredItemId(null)}
                            onClick={() => handleGenreClick(g)}
                        >
                            {/* Оборачиваем текст в обрезающий контейнер */}
                            <div
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "228px",
                                }}
                            >
                                {g.genre}
                            </div>

                            {/* Бейдж остаётся абсолютным — и он больше не будет отрезан
                        {g.assignmentsCount > 0 && (
                            <Badge
                                bg="light"
                                text="dark"
                                pill
                                style={{
                                    position: "absolute",
                                    left:
                                        String(g.assignmentsCount).length === 1
                                            ? "-0.7rem"
                                            : String(g.assignmentsCount).length === 2
                                                ? "-0.8rem"
                                                : "-1rem",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    minWidth: "22px",
                                    textAlign: "center",
                                    border: "1px solid #ccc",
                                    boxShadow: "0 0 2px rgba(0,0,0,0.1)"
                                }}
                            >
                                {g.assignmentsCount}
                            </Badge>
                        )} */}
                        </ListGroup.Item>
                    ))}
            </ListGroup>
        </div>
    );
});

export default ColCategory;
